import React, { useState, useEffect } from 'react';
import AdminNavbar from '../components/adminNavbar';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios'; // Import Axios
import { Country, State, City } from "country-state-city";

const BASE_API_URL = process.env.REACT_APP_API_URL;
const API_URL = `${BASE_API_URL}/Users`;

export default function AdminUserAdd({ setToken }) {
    const navigate = useNavigate();
    const token = localStorage.getItem('token');

    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);

    const [selectedCountry, setSelectedCountry] = useState("");
    const [selectedState, setSelectedState] = useState("");
    const [selectedCity, setSelectedCity] = useState("");

    // Load countries
    useEffect(() => {
        const allCountries = Country.getAllCountries();
        setCountries(allCountries);
    }, []);

    // Load states when country changes
    useEffect(() => {
        if (selectedCountry) {
            const allStates = State.getStatesOfCountry(selectedCountry);
            formData.country = selectedCountry;
            setStates(allStates);
        }
    }, [selectedCountry]);

    // Load cities when state changes
    useEffect(() => {
        if (selectedState) {
            const allCities = City.getCitiesOfState(selectedCountry, selectedState);
            formData.state = selectedState;
            formData.country = selectedCountry;
            setCities(allCities);
        }
    }, [selectedState, selectedCountry]);


    useEffect(() => {
        if (selectedCity) {
            formData.country = selectedCountry;
            formData.state = selectedState;
            formData.userCity = selectedCity;
        }
    }, [selectedCity, selectedState, selectedCountry]);

    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        //dOB: '',
        email: '',
        gender: '',
        bloodGroup: '',
        phoneNumber: '',
        address: '',
        userCity: '',
        state: '',
        country: '',
        zipcode: '',
        password: ''
    });

    const [errors, setErrors] = useState({
        firstName: '',
        lastName: '',
        //dOB: '',
        email: '',
        gender: '',
        bloodGroup: '',
        phoneNumber: '',
        address: '',
        userCity: '',
        state: '',
        country: '',
        zipcode: '',
        password: ''
    });

    const [isLoading, setIsLoading] = useState(false); // State to manage loader visibility

    const validateInput = (name, value) => {
        const errorMessages = {
            firstName: 'First name is required and should only contain characters with no symbols or spaces.',
            lastName: 'Last name should only contain characters with no symbols or spaces.',
            //date: 'Date is required.',
            gender: 'Gender is required.',
            phoneNumber: 'Phone number should only contain numbers, spaces, and "+" with a maximum of 15 digits.',
            email: 'Invalid email address.',
            address: 'Address is required.',
            userCity: 'City is required.',
            state: 'State is required.',
            country: 'Country is required.',
            zipcode: 'Invalid zipcode.',
            password: 'Password is required and should be at least 8 characters long.',
            bloodGroup: 'Blood Group is required'
        };

        switch (name) {
            case 'firstName':
                if (!value.trim()) {
                    return errorMessages.firstName;
                }
                if (!/^[a-zA-Z]+$/.test(value)) {
                    return errorMessages.firstName;
                }
                break;

            case 'lastName':
                if (value && !/^[a-zA-Z]+$/.test(value)) {
                    return errorMessages.lastName;
                }
                break;
            //case 'date':
            //     if (!value.trim()) {
            //          return errorMessages.date;
            //     }
            //     break;
            case 'gender':
                if (!value) {
                    return errorMessages.gender;
                }
                break;
            case 'bloodGroup':
                if (!value) {
                    return errorMessages.bloodGroup;
                }
                break;
            case 'phoneNumber':
                if (!value.trim()) {
                    return errorMessages.phoneNumber;
                }
                if (!/^[\d+ ]{0,15}$/.test(value)) {
                    return errorMessages.phoneNumber;
                }
                break;
            case 'email':
                if (!/\S+@\S+\.\S+/.test(value)) {
                    return errorMessages.email;
                }
                break;
             case 'address':
            case 'userCity':
             case 'state':
             case 'country':
                  if (!value.trim()) {
                       return errorMessages[name];
                  }
                  break;
             case 'zipcode':
                  if (!/^\d{6}$/.test(value)) {
                       return errorMessages.zipcode;
                  }
                  break;
            case 'password':
                if (!value.trim()) {
                    return errorMessages.password;
                }
                if (value.length < 8) {
                    return errorMessages.password;
                }
                break;
            default:
                break;
        }
        return '';
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        const newValue =
            type === 'checkbox'
                ? formData.interestedIn.includes(value)
                    ? formData.interestedIn.filter((item) => item !== value)
                    : [...formData.interestedIn, value]
                : value;

        // Validate the last name field if it's entered (not empty)
        const errorMessage = name === 'lastName' && value.trim() ? validateInput(name, newValue) : '';

        setErrors({ ...errors, [name]: errorMessage });
        setFormData({ ...formData, [name]: newValue });

    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true); // Show loader
        // Validate all form fields on submit
        const newErrors = {};
        Object.keys(formData).forEach((fieldName) => {
            const errorMessage = validateInput(fieldName, formData[fieldName]);
            newErrors[fieldName] = errorMessage;
        });
        console.log(newErrors);
        setErrors(newErrors);

        // Check if there are any errors in the form
        const formHasErrors = Object.values(newErrors).some((error) => error !== '');

        if (!formHasErrors) {
            
            const submitFormData = new FormData();
            // Append each field individually as FormData
            submitFormData.append('FirstName', formData.firstName);
            submitFormData.append('LastName', formData.lastName);
            submitFormData.append('DOB', formData.date);
            submitFormData.append('EmailAddress', formData.email);
            submitFormData.append('Gender', formData.gender);
            submitFormData.append('BloodGroup', formData.bloodGroup);
            submitFormData.append('PhoneNumber', formData.phoneNumber);
            submitFormData.append('HomeAddress', formData.address);
            submitFormData.append('City', formData.userCity);
            submitFormData.append('State', formData.state);
            submitFormData.append('Country', formData.country);
            submitFormData.append('PostalCode', formData.zipcode);
            //submitFormData.append('ProfilePictureUrl', formData.profileImage);
            submitFormData.append('Password', formData.password);
            var response = null;
            var responseErrors = null;
            try {

                response = await axios.post(`${API_URL}`, submitFormData, config);
                if (response.status === 200) {
                    console.log('User registered:', response.data);
                    // Display a success message to the user
                    setFormData({
                        firstName: '',
                        lastName: '',
                        //dOB: '',
                        email: '',
                        gender: '',
                        bloodGroup: '',
                        phoneNumber: '',
                        address: '',
                        userCity: '',
                        state: '',
                        country: '',
                        zipcode: '',
                        password: ''
                    });
                    if (response.data > 0)
                        navigate('/admin/users');
                } else {
                    console.error('User registration failed:', response.data);
                    // Display an error message to the user
                    alert('User registration failed. Please try again.');
                    responseErrors = response.data.errors;
                    if (responseErrors != null) {

                        setErrors({
                            firstName: responseErrors.FirstName?.[0],
                            lastName: responseErrors.LastName?.[0],
                            //date: responseErrors.DOB?.[0],
                            phoneNumber: responseErrors.PhoneNumber?.[0],
                            email: responseErrors.EmailAddress?.[0],
                            password: responseErrors.Password?.[0],
                            bloodGroup: responseErrors.BloodGroup?.[0],
                            //profileImage: responseErrors.ProfilePictureUrl?.[0]
                        });
                    }
                }
            } catch (e) {
                console.log(e);
                responseErrors = e.response.data.errors;
                if (responseErrors != null) {
                    setErrors({
                        firstName: responseErrors.FirstName?.[0],
                        lastName: responseErrors.LastName?.[0],
                        //date: responseErrors.DOB?.[0],
                        phoneNumber: responseErrors.PhoneNumber?.[0],
                        email: responseErrors.EmailAddress?.[0],
                        password: responseErrors.Password?.[0],
                        bloodGroup: responseErrors.BloodGroup?.[0],
                        // profileImage: responseErrors.ProfilePictureUrl?.[0]
                    });
                }
            } finally {
                setIsLoading(false); // Hide loader
            }

        } else {
            setIsLoading(false); // Hide loader if there are validation errors
        }
    };

    const config = {
        headers: {
            Authorization: `Bearer ${token}`
        },
    };
    

     return (
          <>
               <AdminNavbar setToken={setToken} />
               <div className="events">
                    <div className="res-container sm-pt-10">
                         <div className="card p-0">
                              <div className="row">
                                   <div className="col-md-12 p-0">
                                        <div className="card common-card">
                                             <div className="card-header d-flex jc-sb">
                                                  <h3 className="head m-0">Add Users</h3>
                                         <Link to="/admin/users" className="btn btn-outline">
                                                       Back
                                                  </Link>
                                             </div>
                                             <div className="card-body">
                                             
                                                 <form onSubmit={handleSubmit}>
                                                     <div className="row">
                                                         <div className="col-md-6">
                                                             <div className="form-group text-left">
                                                                 <input
                                                                     type="text"
                                                                     className={`form-control mb-0 ${errors.firstName ? 'is-invalid' : ''}`}
                                                                     id="firstName"
                                                                     name="firstName"
                                                                     value={formData.firstName}
                                                                     onChange={handleChange}
                                                                     placeholder="First name"
                                                                 />
                                                                 {errors.firstName && <div className="invalid-feedback">{errors.firstName}</div>}
                                                             </div>
                                                         </div>
                                                         <div className="col-md-6">
                                                             <div className="form-group text-left">
                                                                 <input
                                                                     type="text"
                                                                     className={`form-control mb-0 ${errors.lastName ? 'is-invalid' : ''}`}
                                                                     id="lastName"
                                                                     name="lastName"
                                                                     value={formData.lastName}
                                                                     onChange={handleChange}
                                                                     placeholder="Last name"
                                                                 />
                                                                 {errors.lastName && <div className="invalid-feedback">{errors.lastName}</div>}
                                                             </div>
                                                         </div>
                                                 
                                                 
                                                         <div className="col-md-6">
                                                             <div className="form-group text-left">
                                                                 <input
                                                                     type="text"
                                                                     className={`form-control mb-0 ${errors.phoneNumber ? 'is-invalid' : ''}`}
                                                                     id="phoneNumber"
                                                                     name="phoneNumber"
                                                                     value={formData.phoneNumber}
                                                                     onChange={handleChange}
                                                                     placeholder="Phone number"
                                                                 />
                                                                 {errors.phoneNumber && <div className="invalid-feedback">{errors.phoneNumber}</div>}
                                                             </div>
                                                         </div>
                                                         <div className="col-md-6">
                                                             <div className="form-group text-left">
                                                                 <input
                                                                     type="email"
                                                                     className={`form-control mb-0 ${errors.email ? 'is-invalid' : ''}`}
                                                                     id="email"
                                                                     name="email"
                                                                     value={formData.email}
                                                                     onChange={handleChange}
                                                                     placeholder="Email"
                                                                 />
                                                                 {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                                                             </div>
                                                         </div>
                                                    </div>
                                             <div className="row">
                                                 <div className="col-md-6">
                                                         <div className="form-group text-left">
                                                             <input
                                                                 type="text"
                                                                 className={`form-control mb-0 ${errors.bloodGroup ? 'is-invalid' : ''}`}
                                                                 id="bloodGroup"
                                                                 name="bloodGroup"
                                                                 value={formData.bloodGroup}
                                                                 onChange={handleChange}
                                                                 placeholder="Blood Group"
                                                             />
                                                             {errors.bloodGroup && <div className="invalid-feedback">{errors.bloodGroup}</div>}
                                                     </div>
                                                 </div>
                                                 <div className="col-md-6">
                                                     <div className="form-group text-left">
                                                         <input
                                                             type="text"
                                                             className={`form-control mb-0 ${errors.password ? 'is-invalid' : ''}`}
                                                             id="password"
                                                             name="password"
                                                             value={formData.password}
                                                             onChange={handleChange}
                                                             placeholder="Password"
                                                         />
                                                         {errors.password && <div className="invalid-feedback">{errors.password}</div>}
                                                     </div>
                                                 </div>
                                                     </div>
                                                     <div className="row">
                                                         <div className="col-12">
                                                             <div className="form-group text-center">
                                                                 <div className="d-flex justify-content-left">
                                                                     <label className="mr-30 pt-10">Gender : </label>
                                                                     {/* Male Radio Button */}
                                                                     <label className="mr-20 pt-10">
                                                                         <input
                                                                             type="radio"
                                                                             name="gender"
                                                                             value="male"
                                                                             checked={formData.gender === 'male'}
                                                                             onChange={handleChange}
                                                                     />
                                                                                 <span> Male</span>
                                                                     </label>

                                                                     {/* Female Radio Button */}
                                                                     <label className="mr-20 pt-10">
                                                                         <input
                                                                             type="radio"
                                                                             name="gender"
                                                                             value="female"
                                                                             checked={formData.gender === 'female'}
                                                                             onChange={handleChange}
                                                                     />
                                                                                 <span> Female</span>
                                                                     </label>

                                                                     {/* Other Radio Button */}
                                                                     <label className="mr-20 pt-10">
                                                                         <input
                                                                             type="radio"
                                                                             name="gender"
                                                                             value="other"
                                                                             checked={formData.gender === 'other'}
                                                                             onChange={handleChange}
                                                                     />
                                                                                 <span> Other</span>
                                                                     </label>
                                                                 </div>
                                                                 {errors.gender && <div className="invalid-feedback d-block text-left">{errors.gender}</div>}
                                                             </div>
                                                         </div>

                                                     </div>
                                                     <div className="row">
                                                         <div className="col-12">
                                                             <div className="form-group text-left">
                                                                 <textarea
                                                                     className={`form-control mb-0 ${errors.address ? 'is-invalid' : ''}`}
                                                                     id="address"
                                                                     name="address"
                                                                     value={formData.address}
                                                                     onChange={handleChange}
                                                                     placeholder="Address"
                                                                 />
                                                                 {errors.address && <div className="invalid-feedback">{errors.address}</div>}
                                                             </div>
                                                         </div>
                                                     </div>
                                                     <div className="row">
                                                         <div className="col-6">
                                                             <div className="form-group text-left">

                                                                 <select className="form-control mb-0" onChange={(e) => setSelectedCountry(e.target.value)}>
                                                                     <option>Select Country</option>
                                                                     {countries.map((country) => (
                                                                         <option key={country.isoCode} value={country.isoCode}>
                                                                             {country.name}
                                                                         </option>
                                                                     ))}
                                                         </select>
                                                         {errors.country && <div className="invalid-feedback">{errors.country}</div>}
                                                             </div>
                                                         </div>
                                                         <div className="col-6">
                                                             <div className="form-group text-left">

                                                                 <select className="form-control mb-0" onChange={(e) => setSelectedState(e.target.value)}>
                                                                     <option>Select State</option>
                                                                     {states.map((state) => (
                                                                         <option key={state.isoCode} value={state.isoCode}>
                                                                             {state.name}
                                                                         </option>
                                                                     ))}
                                                         </select>
                                                         {errors.state && <div className="invalid-feedback">{errors.state}</div>}
                                                             </div>
                                                         </div>
                                                     </div>
                                                     <div className="row">
                                                         <div className="col-6">
                                                             <div className="form-group text-left">


                                                         <select className="form-control mb-0" id="userCity" name="userCity" onChange={(e) => setSelectedCity(e.target.value)}>
                                                                     <option>Select City</option>
                                                                     {cities.map((city) => (
                                                                         <option key={city.name}>{city.name}</option>
                                                                     ))}
                                                         </select>
                                                         {errors.userCity && <div className="invalid-feedback">{errors.userCity}</div>}
                                                             </div>
                                                         </div>
                                                         <div className="col-6">
                                                             <div className="form-group text-left">
                                                                 <input
                                                                     type="text"
                                                                     className="form-control mb-0"
                                                                     id="zipcode"
                                                                     name="zipcode"
                                                                     onChange={handleChange}
                                                                     placeholder="Zipcode"
                                                                 />
                                                             </div>
                                                         </div>
                                                     </div>
                                                     <div className="row">
                                                         <div className="col text-right">
                                                             <button type="submit" className="btn btn-primary">
                                                                 Submit
                                                             </button>
                                                         </div>
                                                     </div>

                                                 </form>
                                             
                                             </div>
                                        </div>
                                   </div>
                              </div>
                         </div>
                    </div>
               </div>
          </>
     );
}
